"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseUISettings = exports.parseField = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));
var _toConsumableArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js"));
var _objectSpread2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _settingsHelper = require("../utils/settingsHelper");
var _types = require("./types");
var _validation = require("./validation");
var _excluded = ["fieldDefinitions", "pages", "homePage"];
var fieldDefaults = {
  displayName: 'Label not provided',
  editable: true,
  mandatory: true,
  visible: true
};
var parseField = function parseField(field) {
  var hiddenFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var fieldDefinitions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var parentFields = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var parentField = parentFields.find(function (pf) {
    return pf.id === field.id;
  }) || {};
  var fieldDefinition = fieldDefinitions.find(function (fd) {
    return fd.id === field.id;
  }) || {};
  var fieldWithInheritance = (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, fieldDefaults), fieldDefinition), parentField), field);
  var isHidden = hiddenFields.find(function (id) {
    return id === field.id;
  });
  if (isHidden) {
    fieldWithInheritance.visible = false;
  }
  if (!fieldWithInheritance.visible) {
    fieldWithInheritance.mandatory = false;
  }
  return fieldWithInheritance;
};
exports.parseField = parseField;
var parseFieldsWithInheritance = function parseFieldsWithInheritance(page, subPage, fieldDefinitions) {
  var parentFields = page.fields;
  var parentHiddenFields = page.hiddenFields || [];
  var subPageHiddenFields = subPage.hiddenFields || [];
  var hiddenFields = [].concat((0, _toConsumableArray2.default)(parentHiddenFields), (0, _toConsumableArray2.default)(subPageHiddenFields));
  var parentFieldsWithoutOverrides = parentFields.filter(function (pf) {
    return !(subPage.fields && subPage.fields.find(function (f) {
      return f.id === pf.id;
    }));
  });
  var fieldsWithInheritance = [].concat((0, _toConsumableArray2.default)(subPage.fields), (0, _toConsumableArray2.default)(parentFieldsWithoutOverrides)).map(function (field) {
    return parseField(field, hiddenFields, fieldDefinitions, parentFields);
  });
  return fieldsWithInheritance;
};
var createPage = function createPage(apiPage, fields, hiddenForUsers, userRoles) {
  var _apiPage$visible;
  var defaultPageVisibility = (_apiPage$visible = apiPage.visible) !== null && _apiPage$visible !== void 0 ? _apiPage$visible : true;
  var page = {
    id: apiPage.id,
    displayName: apiPage.displayName,
    fields: fields || [],
    visible: defaultPageVisibility && (0, _settingsHelper.shouldDisplayBasedOnRoles)(hiddenForUsers, userRoles)
  };
  (0, _validation.validatePage)(page);
  return page;
};
var parseTopLevelPage = function parseTopLevelPage(page, fieldDefinitions, userRoles) {
  var _page$fields;
  var mappedFields = (_page$fields = page.fields) === null || _page$fields === void 0 ? void 0 : _page$fields.map(function (field) {
    var hiddenFields = page.hiddenFields || [];
    return parseField(field, hiddenFields, fieldDefinitions);
  });
  var mappedPage = createPage(page, mappedFields, page.hiddenForUsers, userRoles);
  (0, _validation.validatePage)(mappedPage);
  return mappedPage;
};
var parseSubPages = function parseSubPages(page, fieldDefinitions, userRoles) {
  if (!!page.subPages) {
    return page.subPages.flatMap(function (apiSubPage) {
      var fieldsWithInheritance = parseFieldsWithInheritance(page, apiSubPage, fieldDefinitions);
      var subPage = createPage(apiSubPage, fieldsWithInheritance, apiSubPage.hiddenForUsers || page.hiddenForUsers, userRoles);
      if (apiSubPage.subPages) {
        var thirdLevelSubpages = apiSubPage.subPages.map(function (thirdApiLevelSubpage) {
          return createPage(thirdApiLevelSubpage, parseFieldsWithInheritance(subPage, thirdApiLevelSubpage, fieldDefinitions), thirdApiLevelSubpage.hiddenForUsers || apiSubPage.hiddenForUsers || page.hiddenForUsers, userRoles);
        });
        return [subPage].concat((0, _toConsumableArray2.default)(thirdLevelSubpages));
      }
      return [subPage];
    });
  }
  return [];
};
var parseUISettings = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(apiSettings, userRoles) {
    var fieldDefinitions, pages, _apiSettings$homePage, homePage, rest, mappedPages;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _validation.apiUISettingV2Schema.validate(apiSettings);
          case 3:
            fieldDefinitions = apiSettings.fieldDefinitions, pages = apiSettings.pages, _apiSettings$homePage = apiSettings.homePage, homePage = _apiSettings$homePage === void 0 ? 'SPEND' : _apiSettings$homePage, rest = (0, _objectWithoutProperties2.default)(apiSettings, _excluded);
            mappedPages = pages.flatMap(function (page) {
              if (!page.abstract) {
                return [parseTopLevelPage(page, fieldDefinitions, userRoles)].concat((0, _toConsumableArray2.default)(parseSubPages(page, fieldDefinitions, userRoles)));
              }
              return (0, _toConsumableArray2.default)(parseSubPages(page, fieldDefinitions, userRoles));
            });
            return _context.abrupt("return", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, rest), {}, {
              homePage: homePage,
              pages: mappedPages
            }));
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            throw new _types.UISettingsError(_context.t0.message);
          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));
  return function parseUISettings(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
exports.parseUISettings = parseUISettings;